import { render, staticRenderFns } from "./redirectFaq.vue?vue&type=template&id=bbe984d6"
import script from "./redirectFaq.vue?vue&type=script&lang=js"
export * from "./redirectFaq.vue?vue&type=script&lang=js"
import style0 from "./redirectFaq.vue?vue&type=style&index=0&id=bbe984d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe984d6')) {
      api.createRecord('bbe984d6', component.options)
    } else {
      api.reload('bbe984d6', component.options)
    }
    module.hot.accept("./redirectFaq.vue?vue&type=template&id=bbe984d6", function () {
      api.rerender('bbe984d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/faq/componetesFaq/redirectFaq.vue"
export default component.exports